const backendUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:3001" ;

export const apiFetch = async (url, options = {}) => {
    // Get the token from localStorage
    const token = localStorage.getItem('token');
    
    // CSetting up headers if not exists
    options.headers = options.headers || {};
    
    // Add the Authorization header
    if (token) {
        options.headers['Authorization'] = `Bearer ${token}`;
    }

    // Run the fetch
    let fullUrl = url.startsWith("/") || backendUrl.endsWith("/") ? `${backendUrl}${url}` : `${backendUrl}/${url}`;
    if (url.startsWith("http")){
        fullUrl = url;
    }
    const response = await fetch(fullUrl, options);

    // Handle 401 error codes
    if (response.status === 401) {
        window.location.href = '/login';
    }

    return response;
};